import { h } from 'preact'
import { signal } from '@preact/signals'
import { Publicite } from '../publicite/publicite.jsx'

export const bandeAccueilTvState = signal('')

const NDE_FORMAT = '1200x388-1472x981'

const Carrousel = ({ carrousel, format, elementId }) => {
   if (!carrousel) return null

   const version = carrousel.slides?.[0]?.version
   const resolvedFormat = version === 'nde' ? NDE_FORMAT : format
   const slides = JSON.stringify(carrousel.slides)

   if (version === 'nde') {
      return <harmony-carrousel format={resolvedFormat} slides={slides} elementId={elementId} />
   }

   return <harmony-carrousel-legacy format={resolvedFormat} slides={slides} elementId={elementId} />
}

export const BandeAccueilTv = ({ publicite, format, elementId }) => {
   const carrousel = bandeAccueilTvState.value?.carrousel_n1Tv || null

   return (
      <div class="row no-gutters mb-2" data-testid="bande-top-tv">
         <div class="col-12 col-lg-8">
            <Carrousel carrousel={carrousel} format={format} elementId={elementId} />
         </div>
         <div class="col-4 d-none d-lg-block">
            <div class="d-flex align-items-center bg-gray2 h-100" style={{ maxHeight: '310px' }}>
               <Publicite adsId={publicite.rmAdsId} type="rm" />
            </div>
         </div>
      </div>
   )
}
